export const PANELCONTROL = {
    STARAUTO: {
        GetApplicationConfiguration: 'ApplicationConfigurationsService.svc/GetApplicationConfiguration'
    },
    TALLER: {
        CompanyConfiguration: 'WorkshopConfigurationsService.svc/GetCompanyConfiguration',
        NetworkConfigurations: 'NetworkConfigurationsService.svc/GetNetworkConfiguration',
        OperationTypesService: 'OperationTypesService.svc/GetAll',
        VatTypeService: 'VatTypeService.svc/GetAll',
        VatTypeServiceExcempted: 'VatTypeService.svc/GetExempted',
        UpdateNetworkConfiguration: 'NetworkConfigurationsService.svc/UpdateNetworkConfiguration',
        UpdateCompanyConfiguration: 'WorkshopConfigurationsService.svc/UpdateCompanyConfiguration',
        ForfaitZonesService: 'ForfaitZonesService.svc/GetAll',
        FindSuppliersPaged: 'WareHousesService.svc/FindSuppliersPaged',
        indSupplierForInternal: 'CustomerService.svc/FindSupplierForInternalUsePaged',
        CustomerGetByCode: 'CustomerService.svc/GetByCustomerCode',
        SyncAppointments: 'Services/BaseServices/RDVService.svc/SyncAppointments'
    },
    CERTIFICADO: {
        GetInstalledCertificate: 'CertificatesService.svc/GetInstalledCertificate',
        InstallCertificate: 'CertificatesService.svc/InstallCertificate',
        InstallServerCertificate: 'CertificatesService.svc/InstallServerCertificate',
        DeleteCertificate: 'CertificatesService.svc/DeleteCertificate',
        AllServerCertificates: 'CertificatesService.svc/GetAllServerCertificates'
    },
    INTERFACES: {
        GetCompanyConfiguration: 'WorkshopConfigurationsService.svc/GetCompanyConfiguration',
        DeactivateBvv: 'WorkshopConfigurationsService.svc/DeactivateBvv',
        ActivateBvv: 'WorkshopConfigurationsService.svc/ActivateBvv',
        ActivateDDC: 'WorkshopConfigurationsService.svc/ActivateDDC',
        ActivateDDCHistoric:'WorkshopConfigurationsService.svc/ActivateDDCHistoric',
        DeactivateDDCHistoric: 'WorkshopConfigurationsService.svc/DeactivateDDCHistoric',
        DeactivateDDC: 'WorkshopConfigurationsService.svc/DeactivateDDC',
        DeactivateCF: 'WorkshopConfigurationsService.svc/DeactivateCustomerFirst',
        ActivateCF: 'WorkshopConfigurationsService.svc/ActivateCustomerFirst',
        DeactivateCLIPRE: 'WorkshopConfigurationsService.svc/DeactivateClipre',
        ActivateCLIPRE: 'WorkshopConfigurationsService.svc/ActivateClipre',
        CreateInitCLIPRE: 'WorkshopConfigurationsService.svc/CreateInitNextSendClipre',
        PCCSB: {
            urlGetAll: "Services/BaseServices/APVPRParametersService.svc/GetAll",
            urlUpdate: "Services/BaseServices/APVPRParametersService.svc/Update",
            urlAdd: "Services/BaseServices/APVPRParametersService.svc/Add",
            urlDelete: "Services/BaseServices/APVPRParametersService.svc/Delete",
            urlComboWarehouseManager: "Services/WareHouse/ReceptionistService.svc/GetSmallReceptionists",
            urlComboSectionWorkshop: "Services/Workshop/WorkingSectionService.svc/GetAllWorkingSections",
            urlComboWarehouse: "Services/WareHouse/WareHousesService.svc/GetSmallWareHouses"
        },
        RDV: {
            urlGetAll: "Services/BaseServices/RDVService.svc/GetRdvConfiguration",
            urlUpdate: "Services/BaseServices/RDVService.svc/UpdateRdvConfiguration",
            urlCheckConfigurationInterface: "Services/BaseServices/RDVService.svc/SyncAppointments"
        },
        CIF: {
            urlGetInvoicingCifReport: "Services/Brand/InvoicingCifReportService.svc/GetAll",
            urlActivateCIF: "Services/General/WorkshopConfigurationsService.svc/ActivateCIF",
            urlDesactivateCIF: "Services/General/WorkshopConfigurationsService.svc/DeactivateCIF",
            urlGetCompanyConfiguration: "Services/General/WorkshopConfigurationsService.svc/GetCompanyConfiguration",
            urlDeleteCifReport: "Services/Brand/InvoicingCifReportService.svc/Delete",
            urlAddCifReport: "Services/Brand/InvoicingCifReportService.svc/Add"
        }
    },
    CONTABILIDAD: {
        UpdateIntegrationModeInCompanyConfiguration: 'WorkshopConfigurationsService.svc/UpdateIntegrationModeInCompanyConfiguration',
        ChangeStatusAppAccounting: 'ApplicationConfigurationsService.svc/ChangeStatusAppAccounting'
    },
    GESTION_USUARIOS: {
        getAllGestionUsuarios: "Services/BaseServices/UserConfigurationsService.svc/GetAll",
        addGestionUsuarios: "Services/BaseServices/UserConfigurationsService.svc/Add",
        updateGestionUsuarios: "Services/BaseServices/UserConfigurationsService.svc/Update",
        updateUserPassword: "Services/BaseServices/UserConfigurationsService.svc/UpdateUserPassword",
        deleteGestionUsuarios: "Services/BaseServices/UserConfigurationsService.svc/DeleteUser",
        urlGetComboPCsSb: "Services/BaseServices/APVPRParametersService.svc/GetSmallAPVPRParameters",
        urlGetComboRole: "Services/BaseServices/ProfilesService.svc/GetAll",
        urlGetComboComboStoreDefault: "Services/WareHouse/WareHousesService.svc/GetSmallWareHouses",
        urlGetComboManagerStore: "Services/WareHouse/ReceptionistService.svc/GetSmallReceptionists",
        urlCheckPassword: "Services/BaseServices/UserConfigurationsService.svc/CheckPassword",
        urlGetUserByName: "Services/BaseServices/UserConfigurationsService.svc/GetUserByName"
    },
    GESTION_SMS: {
        urlgetAll: "Services/General/SMSService.svc/GetSMSConfiguration",
        urlUpdate: "Services/General/SMSService.svc/UpdateSMSConfiguration",
        urlComboTypeSms: "Services/General/MessageService.svc/GetSMSTemplates",
        urlQuantitySms: "Services/General/SMSService.svc/GetSMSQuantity",
        cleanSMSConfiguration: "Services/General/SMSService.svc/CleanSMSConfiguration"
    },
    PRODUCTIVIDAD: {
        urlGetTreeViewAlerts: "Services/BaseServices/NotificationAlertsService.svc/GetTreeViewAlerts"
    },
    GESTION_EMAIL: {
        urlgetAll: "Services/BaseServices/SmtpConfigurationsService.svc/GetSmtpConfiguration",
        urlUpdate: "Services/BaseServices/SmtpConfigurationsService.svc/UpdateSmtpConfiguration",
        urlComboSendingServer: "Services/BaseServices/SmtpConfigurationsService.svc/GetDefaultSmtpServers",
        urlComboTypeEmail: "Services/General/MessageService.svc/GetEmailTemplates",
        urlUpdateTemplates: "Services/General/MessageService.svc/UpdateAllTemplates",
    },
    GESTION_HORARIOS: {
        HORARIOS_APERTURA: {
            AddWorkCalendar: "Services/General/CalendarsService.svc/AddWorkCalendar",
            UpdateWorkCalendar: "Services/General/CalendarsService.svc/UpdateWorkCalendar",
            DeleteWorkCalendarAndWorkHoursById: "Services/General/CalendarsService.svc/DeleteWorkCalendarAndWorkHoursById",
            AddWorkHours: "Services/General/OpeningHoursService.svc/AddWorkHours",
            GetWorkCalendarById: "Services/General/CalendarsService.svc/GetWorkCalendarById",
            GetAllCalendars: "Services/General/CalendarsService.svc/GetAll"
        },
        PERIODOS_CIERRE: {
            ComboMotivos: 'Services/General/ClosingHoursService.svc/GetAllClosedTypes',
            GetAllWorkHours: 'Services/General/ClosingHoursService.svc/GetAll',
            AddWorkClosedDate: 'Services/General/ClosingHoursService.svc/AddWorkClosedDate',
            UpdateWorkClosedDate: 'Services/General/ClosingHoursService.svc/UpdateWorkClosedDate',
            DeleteWorkClosedDate: 'Services/General/ClosingHoursService.svc/DeleteWorkClosedDate'
        }
    }
}
